module.exports = __webpack_public_path__ + "img/img_placeholder2.5aedbfb7.png";